module.exports = __webpack_public_path__ + "static/media/inquiry_form_black.d2ab9a31.svg";